import { Box } from "@mui/material";

export const DataGridContainer = ({ children }) => (
  <Box
    sx={{
      width: 1,
      flex: 1,
    }}
  >
    {children}
  </Box>
);
